module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrorMessage),
      expression: "showErrorMessage"
    }],
    staticClass: "alert alert-danger infoMessage",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.errorMessage))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSuccessMessage),
      expression: "showSuccessMessage"
    }],
    staticClass: "alert alert-success infoMessage",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.successMessage))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-29186896", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29186896"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/InfoMessage.vue
// module id = 108
// module chunks = 0